// Swiper
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

// Extend webpack window classes
window.Swiper = Swiper;
